import * as React from 'react';
import {Aperture, Camera, Globe, Heart, Rainbow, Sparkles, Zap} from 'lucide-react';
import {BRAND} from '../brand';

// Icons a brand can name as `logo.icon` in config/brands.yml.
const ICONS: Record<string, React.FC<{className?: string}>> = {
    aperture: Aperture, camera: Camera, globe: Globe, heart: Heart, rainbow: Rainbow, sparkles: Sparkles, zap: Zap,
};

// The brand's mark: its logo image when it has one, otherwise its named icon.
const BrandLogo: React.FC<{className?: string}> = ({className}) => {
    if (BRAND.logo.image) return <img src={BRAND.logo.image} alt="" className={`${className ?? ''} object-contain`}/>;
    const Icon = ICONS[BRAND.logo.icon ?? ''] ?? Aperture;
    return <Icon className={className}/>;
};

export default BrandLogo;
